import React from "react";

export default function NewCalendar({ className }) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="29394D"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.91602 2.91667C2.59385 2.91667 2.33268 3.17783 2.33268 3.5V11.6667C2.33268 11.9888 2.59385 12.25 2.91602 12.25H11.0827C11.4048 12.25 11.666 11.9888 11.666 11.6667V3.5C11.666 3.17783 11.4048 2.91667 11.0827 2.91667H2.91602ZM1.16602 3.5C1.16602 2.5335 1.94952 1.75 2.91602 1.75H11.0827C12.0492 1.75 12.8327 2.5335 12.8327 3.5V11.6667C12.8327 12.6332 12.0492 13.4167 11.0827 13.4167H2.91602C1.94952 13.4167 1.16602 12.6332 1.16602 11.6667V3.5Z"
        fill="#29394D"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.33333 0.583984C9.6555 0.583984 9.91667 0.845152 9.91667 1.16732V3.50065C9.91667 3.82282 9.6555 4.08398 9.33333 4.08398C9.01117 4.08398 8.75 3.82282 8.75 3.50065V1.16732C8.75 0.845152 9.01117 0.583984 9.33333 0.583984Z"
        fill="#29394D"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.66732 0.583984C4.98948 0.583984 5.25065 0.845152 5.25065 1.16732V3.50065C5.25065 3.82282 4.98948 4.08398 4.66732 4.08398C4.34515 4.08398 4.08398 3.82282 4.08398 3.50065V1.16732C4.08398 0.845152 4.34515 0.583984 4.66732 0.583984Z"
        fill="#29394D"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.16602 5.83333C1.16602 5.51117 1.42718 5.25 1.74935 5.25H12.2493C12.5715 5.25 12.8327 5.51117 12.8327 5.83333C12.8327 6.1555 12.5715 6.41667 12.2493 6.41667H1.74935C1.42718 6.41667 1.16602 6.1555 1.16602 5.83333Z"
        fill="#29394D"
      />
    </svg>
  );
}
